import React, {Component} from 'react'
import {RadioGroup} from "@mui/material";
import {QuestionLabel, QuestionRadio, QuestionCheckbox, CheckboxTooltip } from 'Components/SideQuestionComponents';
import * as Apis from 'Api';
import {NotificationManager} from "react-notifications";
import {connect} from "react-redux";
import {Input} from "reactstrap";



const followUpQuestion = [

    {
        id: 'lungEDUK1',
        label: '',
        options: ["LDCT in 3 months", "LDCT in 9 months", "LDCT in 12 months", "LDCT in 24 months", "Refer to Screening Review Meeting"],
        placeholder:"Select a follow-up recommendation…",
        tooltip: "Lung screening follow-up recommendations is based on the British Thoracic Society guidelines applied to the risk dominant nodule.",
        type: 'radiobutton',
        default: ''
    },
]

const clinicalInfoQuestion = [

    {
        id: 'lungEDUK2',
        label: 'Emphysema',
        options: ['None', 'Mild' ,'Moderate','Severe'],
        type: 'radiobutton',
        default: 'None'
    },
    {
        id: 'lungEDUK3',
        label: 'Coronary artery calcium',
        options: ['None', 'Mild' ,'Moderate','Severe','Previous intervention'],
        type: 'radiobutton',
        default: 'None'
    },
]

const incidentalFindingsQuestion = [

    {
        id: 'lungEDUK4',
        label: 'Would you refer for any actionable incidental findings?',
        options: ['No', 'Yes'],
        type: 'radiobutton',
        default: 'No',
        child: [{
            id: 'lungEDUK4-sub1',
            label: 'Incidental Pulmonary Findings',
            options: ['Severe Bronchiectasis', 'Interstitial Lung Abnormalities >10% of total lung volume','Infective consolidation','Active tuberculosis'],
            type: 'checkbox',
            default: '',
            child: []
        },
            {
                id: 'lungEDUK4-sub2',
                label: 'Incidental Intrathoracic Findings',
                options: ['Mediastinal mass (including lymph nodes)', 'Aortic valve calcium – moderate or severe','Thoracic aortic aneurysm >4.5cm','Pleural effusion/thickening or mass'],
                type: 'checkbox',
                default: '',
                child: []
            },
            {
                id: 'lungEDUK4-sub3',
                label: 'Extrathoracic Incidental Findings',
                options: ['Suspicious Breast lesion', 'Suspicious Thyroid lesion','Suspicious Gastro-oesophageal lesion',
                    'Indeterminate Liver or splenic lesion','Indeterminate Renal lesion','Indeterminate Adrenal lesion','Abdominal aortic aneurysm >3cm',
                    'Bones: Osteoporotic fracture > 50%','Bones: Malignant lytic or sclerotic features'],
                type: 'checkbox',
                default: '',
                child: [],
            },
        ],
        showChildOptions: ['Yes']
    },

]


const targetedLungQuestion = [

    {
        id: 'lungEDUK5',
        label: 'Alert Level',
        options: ['Green', 'Yellow' ,'Orange','Red','Purple (Critical)'],
        type: 'radiobutton',
        default: '',
        placeholder:"Please select an alert level…",
    },
]

const chestLateralQuestion = [
]

class LungEDUKQuestions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            answerValue: {},  // example: {'Ground-Glass Opacity': {0: 'Upper', 1: 'Anterior'}, 'Consolidation': {}}
            answerRating: -1,
            truthValue: {}
        }
        if (props.modalityInfo.name.indexOf('Lateral') === -1) {
            // ImagED - Chest Question
            this.followUpQuestion = followUpQuestion;
            this.clinicalInfoQuestion = clinicalInfoQuestion;
            this.incidentalFindingsQuestion = incidentalFindingsQuestion;
            this.targetedLungQuestion = targetedLungQuestion;

        } else {
            // ImagED - Chest Lateral Question
            this.question = chestLateralQuestion;
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        Apis.getAttemptChestAnswer(this.props.attempts_id, this.props.test_case_id, this.props.isPostTest).then(resp => {
            this.setState({
                answerValue: resp.chest_answer,
                truthValue: resp.chest_truth,
            });
        }).catch(error => {

        });
    }

    saveChestAnswer() {
        if (!this.props.complete) {
            Apis.setAttemptChestAnswer(this.props.attempts_id, this.props.test_case_id, this.state.answerRating, this.state.answerValue, this.props.isPostTest).then(resp => {

            }).catch(error => {
                NotificationManager.error(error.response ? error.response.data.error.message : error.message);
            });
        }
    }

    checkQuestionValidate() {
        const { answerValue } = this.state;

        const isChildQuestionsAnswered = (children, childValues) => {
            if(!childValues)
                return  false;
            return children.every(child => {

                const hasSelectedOption = child.options.some(option => childValues.includes(option));
                return hasSelectedOption;
            });
        };

        // Check all main questions
        const allMainQuestionsAnswered = [
            ...this.followUpQuestion,
            ...this.clinicalInfoQuestion,
            ...this.targetedLungQuestion,
            ...this.incidentalFindingsQuestion
        ].every(q => {
            if (!answerValue[q.id]) {
                return false;
            }
            // Special check for incidentalFindingsQuestion

            if (q.id === 'lungEDUK4' && answerValue[q.id].value === 'Yes') {
                return isChildQuestionsAnswered(q.child, answerValue[q.id].childValue);
            }
            return true;
        });

        if (allMainQuestionsAnswered) {
            return true;
        } else {
            NotificationManager.error("Please select values for all questions.");
            return false;
        }
    }


    onChangeCheck(qId, childQId, value) {
        const {answerValue} = this.state;
        let checkValues = answerValue[qId][childQId];
        if (checkValues === undefined) checkValues = [];
        const valueIndex = checkValues.indexOf(value);
        if (valueIndex === -1) {
            // chestQ3a/chestQ3a has to be 0 or R, L
            if (qId === 'chestQ3a' && (childQId === 'q3cValues' || childQId.indexOf('q3bChest') === 0 || childQId.indexOf('q3cChest') === 0)) {
                if (value === '0') {
                    checkValues = [];
                } else {
                    const zeroIndex = checkValues.indexOf('0');
                    if (zeroIndex !== -1) checkValues.splice(zeroIndex, 1);
                }
            }

            checkValues.push(value);
        } else {
            checkValues.splice(valueIndex, 1);
        }
        answerValue[qId][childQId] = checkValues;
        this.setState({answerValue: {...answerValue}}, () => {
            this.saveChestAnswer();
        });
    }

    onChangeChildValue(qId, childQId, value) {
        const {answerValue} = this.state;
        answerValue[qId][childQId] = value;
        this.setState({answerValue: {...answerValue}}, () => {
            this.saveChestAnswer();
        });
    }

    onChangeQuestion(qId, value) {
        const {answerValue} = this.state;
        if (answerValue[qId] === undefined || answerValue[qId].value !== value) {
            answerValue[qId] = {};
        }
        answerValue[qId].value = value;
        this.setState({answerValue: {...answerValue}}, () => {
            this.saveChestAnswer();
        });
    }

    renderCheckList(values, disabled, qId, childQId) {
        const {answerValue, truthValue} = this.state;
        const qTruths = (truthValue[qId] !== undefined && truthValue[qId][childQId] !== undefined) ? truthValue[qId][childQId] : [];
        let checkValues = (answerValue[qId] !== undefined && answerValue[qId][childQId] !== undefined) ? answerValue[qId][childQId] : [];
        if (checkValues === undefined) checkValues = [];
        return values.map((v, i) => (
            <QuestionLabel key={i} disabled={disabled} control={
                <QuestionCheckbox
                    icon={<span className={'chest-question-checkbox-icon ' + (qTruths.indexOf(v.value) !== -1 ? 'truth-icon' : '')}/>}
                    checkedIcon={<span className={'chest-question-checkbox-icon checked ' + (qTruths.indexOf(v.value) !== -1 ? 'truth-icon' : '')}/>}
                    disableRipple
                    checked={checkValues.indexOf(v.value) !== -1}
                    onChange={() => this.onChangeCheck(qId, childQId, v.value)}
                    name={childQId}
                />
            } label={v.label} className={'align-items-start'}
            />
        ));
    }

    renderAdditionalQuestion(questionObj, disabled) {
        const {answerValue, truthValue} = this.state;
        if (answerValue[questionObj.id] === undefined && truthValue[questionObj.id] === undefined) return null;
        const answerExist = answerValue[questionObj.id] !== undefined && answerValue[questionObj.id].value !== undefined;
        const truthExist = truthValue[questionObj.id] !== undefined && truthValue[questionObj.id].value !== undefined;

        if (
            questionObj.showChildOptions && (
                (answerExist && questionObj.showChildOptions.indexOf(answerValue[questionObj.id].value) !== -1) ||
                (truthExist && questionObj.showChildOptions.indexOf(truthValue[questionObj.id].value) !== -1)
            )
        ) {
            return (


                        questionObj.child.map((c, i) => (
                            <div key={c.id} className={'chest-question'}>
                                <div className={'chest-question-title'}>{c.label}</div>

                                <div className={c.id} key={c.id}>
                                    {
                                        this.renderCheckList(c.options.map((v) => ({label: v, value: v})), disabled, questionObj.id, 'childValue')
                                    }
                                </div>
                            </div>
                        ))


            )
        }
    }

    renderDropDownQuestion(questionObj, index, disabled) {
        const {answerValue, truthValue} = this.state;
        const qTruth = truthValue[questionObj.id] !== undefined ? truthValue[questionObj.id].value : '';
        return (
            <div key={questionObj.id} className={'chest-question'}>
                <div className={'chest-question-title d-flex'}>
                    <span className={'me-1'}></span>

                    {/* Conditionally wrap label with CheckboxTooltip */}
                    {questionObj.tooltip ? (
                        <CheckboxTooltip title={questionObj.tooltip} arrow>
                            <span style={{ flex: 1, cursor: 'pointer' }}>{questionObj.label}</span>
                        </CheckboxTooltip>
                    ) : (
                        <span style={{ flex: 1 }}>{questionObj.label}</span>
                    )}
                </div>
                <div className={'ms-20 mt-10'}>
                    <Input
                        type="select" className="chest-question-select"
                        value={answerValue[questionObj.id] ? answerValue[questionObj.id].value : ''}
                        onChange={(e) => (disabled ? null : this.onChangeQuestion(questionObj.id, e.target.value))}
                        disabled={disabled}>
                        {/* Add placeholder as the first option */}
                        {questionObj.placeholder && (
                            <option value="" disabled>
                                {questionObj.placeholder}
                            </option>
                        )}
                        {
                            questionObj.dropList.map((v) =>
                                <option value={v} key={v}>{v}</option>
                            )
                        }
                    </Input>
                </div>
            </div>
        )
    }

    renderRadioButtonQuestionWithChildren(questionObj, index, disabled) {
        const {answerValue, truthValue} = this.state;
        const qTruth = truthValue[questionObj.id] !== undefined ? truthValue[questionObj.id].value : '';
        return (
            <div key={questionObj.id} className={'chest-question'}>
                <div className={'chest-question-title d-flex'}>
                    <span className={'me-1'}></span><span style={{flex: 1}}>{questionObj.label}</span>
                </div>
                <RadioGroup
                    className={'ms-4'}
                    aria-label="position"
                    name="position"
                    value={answerValue[questionObj.id] ? answerValue[questionObj.id].value : ''}
                    onChange={(event) => (disabled ? null : this.onChangeQuestion(questionObj.id, event.target.value))}
                    row
                    disabled={disabled}
                >
                    {
                        questionObj.options.map((v) => (
                            <QuestionLabel
                                key={v}
                                value={v}
                                control={
                                    <QuestionRadio
                                        icon={<span className={'chest-question-radio-icon ' + (qTruth === v ? 'truth-icon' : '')}/>}
                                        checkedIcon={<span className={'chest-question-radio-icon checked ' + (qTruth === v ? 'truth-icon' : '')}/>}
                                        disableRipple
                                    />
                                }
                                label={v}
                                labelPlacement="end"
                                disabled={disabled}
                            />
                        ))
                    }
                </RadioGroup>
                {this.renderAdditionalQuestion(questionObj, disabled)}
            </div>
        )
    }
    renderColoredRadioButtonQuestion(questionObj, index, disabled) {
        const { answerValue, truthValue } = this.state;
        const qTruth = truthValue[questionObj.id] !== undefined ? truthValue[questionObj.id].value : '';

        // Map to associate each option with its corresponding color
        const colorMap = {
            'Green': 'green',
            'Yellow': 'yellow',
            'Orange': 'orange',
            'Red': 'red',
            'Purple (Critical)': 'purple'
        };

        return (
            <div key={questionObj.id} className={'chest-question'}>
                <div className={'chest-question-title d-flex'}>
                    <span className={'me-1'}></span><span style={{flex: 1}}>{questionObj.label}</span>
                </div>
                <RadioGroup
                    className={'ms-4'}
                    aria-label="position"
                    name="position"
                    value={answerValue[questionObj.id] ? answerValue[questionObj.id].value : ''}
                    onChange={(event) => (disabled ? null : this.onChangeQuestion(questionObj.id, event.target.value))}
                    row
                    disabled={disabled}
                >
                    {
                        questionObj.options.map((v) => (
                            <QuestionLabel
                                key={v}
                                value={v}
                                control={
                                    <QuestionRadio
                                        icon={<span className={'chest-question-radio-icon ' + (qTruth === v ? 'truth-icon' : '')}/>}
                                        checkedIcon={<span className={'chest-question-radio-icon checked ' + (qTruth === v ? 'truth-icon' : '')}/>}
                                        disableRipple
                                    />
                                }
                                label={<span style={{ color: colorMap[v] }}>{v}</span>} // Apply the color to the label
                                labelPlacement="end"
                                disabled={disabled}
                            />
                        ))
                    }
                </RadioGroup>

            </div>
        );
    }


    renderRadioButtonQuestion(questionObj, index, disabled) {
        const { answerValue, truthValue } = this.state;
        const qTruth = truthValue[questionObj.id] !== undefined ? truthValue[questionObj.id].value : '';


        return (
            <div key={questionObj.id} className={'chest-question'}>
                <div className={'chest-question-title d-flex'}>
                    <span className={'me-1'}></span><span style={{flex: 1}}>{questionObj.label}</span>
                </div>
                <RadioGroup
                    className={'ms-4'}
                    aria-label="position"
                    name="position"
                    value={answerValue[questionObj.id] ? answerValue[questionObj.id].value : ''}
                    onChange={(event) => (disabled ? null : this.onChangeQuestion(questionObj.id, event.target.value))}
                    row
                    disabled={disabled}
                >
                    {
                        questionObj.options.map((v) => (
                            <QuestionLabel
                                key={v}
                                value={v}
                                control={
                                    <QuestionRadio
                                        icon={<span className={'chest-question-radio-icon ' + (qTruth === v ? 'truth-icon' : '')}/>}
                                        checkedIcon={<span className={'chest-question-radio-icon checked ' + (qTruth === v ? 'truth-icon' : '')}/>}
                                        disableRipple
                                    />
                                }
                                label={v} // Apply the color to the label
                                labelPlacement="end"
                                disabled={disabled}
                            />
                        ))
                    }
                </RadioGroup>

            </div>
        );
    }


    render() {
        const disabled = this.props.complete;
        return (
            <div className={'ps-10 covid-question-container chest-data'}>
                <div>
                    <div className={'covid-questions'}>


                        <CheckboxTooltip title="Lung screening follow-up recommendations is based on the British Thoracic Society guidelines applied to the risk dominant nodule." arrow>
                        <h4 className={'chest-question'}>Follow-up</h4>
                        </CheckboxTooltip>
                        {
                            this.followUpQuestion.map((v, i) => this.renderRadioButtonQuestion(v, i + 1, disabled))
                        }

                        <h4 className={'chest-question'} style={{ marginTop: '30px' }}>Clinical Information</h4>

                        {
                            this.clinicalInfoQuestion.map((v, i) => this.renderRadioButtonQuestion(v, i + 1, disabled))
                        }

                        <h4 className={'chest-question'} style={{ marginTop: '30px' }}>Incidental Findings</h4>

                        {
                            this.incidentalFindingsQuestion.map((v, i) => this.renderRadioButtonQuestionWithChildren(v, i + 1, disabled))
                        }


                        <h4 className={'chest-question'} style={{ marginTop: '30px' }}>Targeted Lung Health Check</h4>

                        {
                            this.targetedLungQuestion.map((v, i) => this.renderColoredRadioButtonQuestion(v, i + 1, disabled))
                        }
                    </div>
                </div>
            </div>
        )
    }
}

// map state to props
const mapStateToProps = (state) => {
    return {
        modalityInfo: state.testView.modalityInfo
    };
};

export default connect(mapStateToProps, null, null, {forwardRef: true})(LungEDUKQuestions);

